module.exports = __webpack_public_path__ + "img/icon-nossa-missao-ccc20239.png";